import { render, staticRenderFns } from "./en-activity.vue?vue&type=template&id=0bd1976f&scoped=true"
import script from "./en-activity.vue?vue&type=script&lang=js"
export * from "./en-activity.vue?vue&type=script&lang=js"
import style0 from "./en-activity.vue?vue&type=style&index=0&id=0bd1976f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1976f",
  null
  
)

export default component.exports